(() => {
	const selector = "img:not([loading]), iframe:not([loading])";
	const viewportBuffer = 1.5;

	const shouldLazyLoad = (element) => {
		if (element.closest("[data-eager-load], [data-no-lazyload]")) return false;
		if (element.getAttribute("fetchpriority") === "high") return false;

		const bounds = element.getBoundingClientRect();
		return element.offsetParent === null || bounds.top > window.innerHeight * viewportBuffer;
	};

	const applyNativeLoading = (root) => {
		const elements = root.matches?.(selector)
			? [root]
			: root.querySelectorAll?.(selector) || [];

		elements.forEach((element) => {
			if (shouldLazyLoad(element)) element.loading = "lazy";
		});
	};

	const initialize = () => {
		applyNativeLoading(document.body);

		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				mutation.addedNodes.forEach((node) => {
					if (node.nodeType !== Node.ELEMENT_NODE) return;
					requestAnimationFrame(() => applyNativeLoading(node));
				});
			});
		});

		observer.observe(document.body, { childList: true, subtree: true });
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initialize, { once: true });
	} else {
		initialize();
	}
})();
